module.exports = __webpack_public_path__ + "static/media/begeleider.0723f6ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/begeleider.svg
// module id = 836
// module chunks = 0